export default __webpack_public_path__ + "static/media/micaela-olocco-1.e851eb2b.webp";